import { createNavigation } from "next-intl/navigation";

import { routing } from "./routing";

// 带 locale 感知的导航 API：Link 会自动补全当前 locale 前缀，
// usePathname 返回的是去 locale 的 pathname（切换语言时替换首段即可）。
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
